import { Axios } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * Stripe Connect payout onboarding link. The server derives the account from the
 * JWT (body is `{}`) and returns a hosted onboarding `{ url }`; web redirects the
 * full page there so SSN/bank PII is collected on Stripe's domain, never ours.
 * Returns the response data; undefined on error.
 */
/**
 * Stripe needs an email before it will open a connected account, and a payee
 * invited by SMS has none. That is a prompt to add one, not a failure, so the
 * caller collects it and retries rather than showing a toast nobody can act on.
 */
export const EMAIL_REQUIRED_FOR_PAYOUTS = "EMAIL_REQUIRED_FOR_PAYOUTS";

const needsEmailFirst = (e) =>
  e?.response?.data?.code === EMAIL_REQUIRED_FOR_PAYOUTS;

export const createOnboardingLink = async () => {
  try {
    const response = await Axios.post("stripe/connect/onboarding-link", {});
    return response?.data;
  } catch (e) {
    if (needsEmailFirst(e)) {
      return { emailRequired: true };
    }
    SimpleCatchError(e);
  }
};
